export default __webpack_public_path__ + "static/media/IMG_4422.56ba4923.jpg";